import React, { createContext, useContext, useState } from "react";
import SystemBrowserPopup from "./index";
import Portal from "../Portal";

interface SystemBrowserPopupContextType {
  showPopup: () => void;
}

const SystemBrowserPopupContext = createContext<
  SystemBrowserPopupContextType | undefined
>(undefined);

export const SystemBrowserPopupProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [show, setShow] = useState(false);

  const showPopup = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  return (
    <SystemBrowserPopupContext.Provider value={{ showPopup }}>
      {children}
      {show && (
        <Portal>
          <SystemBrowserPopup show={show} onClose={handleClose} />
        </Portal>
      )}
    </SystemBrowserPopupContext.Provider>
  );
};

export const useSystemBrowserPopup = () => {
  const context = useContext(SystemBrowserPopupContext);
  if (context === undefined) {
    throw new Error(
      "useSystemBrowserPopup must be used within a SystemBrowserPopupProvider"
    );
  }
  return context;
};
